import React, { FC } from 'react';
import scrollToElement from 'scroll-to-element';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './page_nav_item.module.scss';
import { OutlineItem } from '../pageNav.types';
import { InjectedIntlProps } from '../../../doctrine.types';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = {
  navItem: OutlineItem;
} & InjectedIntlProps;

export const RawPageNavItem: FC<Props> = ({ navItem, intl }) => {
  const getNavItemTitle = () => {
    if (navItem.text) return navItem.text;
    if (navItem.label)
      return intl.formatMessage({
        id: navItem.label,
      });
    return '';
  };

  const goToId = () => {
    const { id } = navItem;
    scrollToElement(`#${id}`, {
      offset: -130,
      ease: 'out-quart',
      duration: 500,
    });
    doctrineAnalytics('PageNav NavItemClicked', {
      id,
      title: getNavItemTitle(),
    });
  };

  return (
    <div onClick={goToId} className={styles.item}>
      {navItem.text ||
        (navItem.label ? <FormattedMessage id={navItem.label} /> : '')}
    </div>
  );
};

export const PageNavItem = injectIntl(RawPageNavItem);
